export default {

	init() {
		const htmlElement = document.documentElement;
		htmlElement.classList.remove('no-js');
		htmlElement.classList.add('js');

		this.scrollbarWidth();
	},

	scrollbarWidth() {
		let scrollbarWidth = window.innerWidth - document.body.clientWidth;
		let root = document.querySelector(':root');

		root.style.setProperty('--scrollbar-width', `${scrollbarWidth}px`);
	},

	getPrefersReducedMotion() {
		return window.matchMedia(
			"(prefers-reduced-motion: reduce)",
		).matches;
	},

	getViewportWidth() {
		return Math.max(
			document.body.scrollWidth,
			document.documentElement.scrollWidth,
			document.body.offsetWidth,
			document.documentElement.offsetWidth,
			document.documentElement.clientWidth
		)
	},

	isMobile() {
		return window.matchMedia('(max-width: 1023px)').matches;
	}

};
